function routes($stateProvider) {
    $stateProvider
        .state('evaluation.learningEngagement.aspect', {
            name: 'aspect',
            params: {
                aspectNr: '0'
            },
            url: '/:aspectNr',
            views: {
                'content': { template: '<aspect></aspect>' }
            }
        })
        .state('mini.learningEngagement.aspect', {
            name: 'aspect',
            params: {
                aspectNr: '0'
            },
            url: '/:aspectNr',
            views: {
                'content': { template: '<aspect></aspect>' }
            }
        });
}

routes.$inject = [
    '$stateProvider'
];

export default routes;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepLearningEngagement/stepLearningEngagementRoutes.js